var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-device-list tenant-list animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "b-card",
              [
                _c(
                  "h1",
                  { staticClass: "lbv-page-title tenantPage" },
                  [
                    _vm._v("\n          Tenant List\n          "),
                    _c(
                      "b-btn",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.modalAddTenant",
                            modifiers: { modalAddTenant: true },
                          },
                        ],
                        staticClass: "addTenantBtn",
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.showModal = true
                          },
                        },
                        model: {
                          value: _vm.addTenant,
                          callback: function ($$v) {
                            _vm.addTenant = $$v
                          },
                          expression: "addTenant",
                        },
                      },
                      [_vm._v("\n            Add New Tenant\n          ")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    responsive: "",
                    striped: "",
                    hover: "",
                    items: _vm.tenantsList,
                    fields: _vm.fields,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "name",
                      fn: function (data) {
                        return [
                          _c(
                            "b-link",
                            {
                              staticClass: "tenantLink",
                              on: {
                                click: function ($event) {
                                  return _vm.editTenant(data)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.value) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c(
                  "b-modal",
                  {
                    attrs: {
                      id: "modalAddTenant",
                      title: "Add Tenant",
                      "ok-variant": "primary",
                      "ok-title": "Add Tenant",
                      "cancel-title": "Cancel",
                    },
                    on: { ok: _vm.addTenant },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("p", [_c("strong", [_vm._v("Name")])]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.tenantName,
                                callback: function ($$v) {
                                  _vm.tenantName = $$v
                                },
                                expression: "tenantName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [_c("strong", [_vm._v("Tenant Code")])]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.tenantCode,
                                callback: function ($$v) {
                                  _vm.tenantCode = $$v
                                },
                                expression: "tenantCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Leak Days Threshold")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.leakDaysThreshold,
                                callback: function ($$v) {
                                  _vm.leakDaysThreshold = $$v
                                },
                                expression: "leakDaysThreshold",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Leak Reminder Frequency")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.leakReminderFrequency,
                                callback: function ($$v) {
                                  _vm.leakReminderFrequency = $$v
                                },
                                expression: "leakReminderFrequency",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Max Number Of Leak Alert Reminders"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.maxNumberOfLeakAlertReminders,
                                callback: function ($$v) {
                                  _vm.maxNumberOfLeakAlertReminders = $$v
                                },
                                expression: "maxNumberOfLeakAlertReminders",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Monthly Updates Frequency"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.monthlyUpdatesFrequency,
                                callback: function ($$v) {
                                  _vm.monthlyUpdatesFrequency = $$v
                                },
                                expression: "monthlyUpdatesFrequency",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Install Chasers Frequency"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.installChasersFrequency,
                                callback: function ($$v) {
                                  _vm.installChasersFrequency = $$v
                                },
                                expression: "installChasersFrequency",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Max Number of Install Chasers"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.maxNumberOfInstallChasers,
                                callback: function ($$v) {
                                  _vm.maxNumberOfInstallChasers = $$v
                                },
                                expression: "maxNumberOfInstallChasers",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Lost Connection Frequency"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.lostConnectionFrequency,
                                callback: function ($$v) {
                                  _vm.lostConnectionFrequency = $$v
                                },
                                expression: "lostConnectionFrequency",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  "Max Number of Lost Connection Reminders"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.maxNumberofLostConnectionReminders,
                                callback: function ($$v) {
                                  _vm.maxNumberofLostConnectionReminders = $$v
                                },
                                expression:
                                  "maxNumberofLostConnectionReminders",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Frozen Pipe Threshold")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.frozenPipeThreshold,
                                callback: function ($$v) {
                                  _vm.frozenPipeThreshold = $$v
                                },
                                expression: "frozenPipeThreshold",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-6 left" },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.surveyAllowed,
                                  callback: function ($$v) {
                                    _vm.surveyAllowed = $$v
                                  },
                                  expression: "surveyAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Survey Allowed\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.waterUsageAllowed,
                                  callback: function ($$v) {
                                    _vm.waterUsageAllowed = $$v
                                  },
                                  expression: "waterUsageAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Water Usage Allowed\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.leakDaysAllowed,
                                  callback: function ($$v) {
                                    _vm.leakDaysAllowed = $$v
                                  },
                                  expression: "leakDaysAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Leak Days Allowed\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.monthlyUpdatesAllowed,
                                  callback: function ($$v) {
                                    _vm.monthlyUpdatesAllowed = $$v
                                  },
                                  expression: "monthlyUpdatesAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Monthly Updates Allowed\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.vacantPropertyLeakTest,
                                  callback: function ($$v) {
                                    _vm.vacantPropertyLeakTest = $$v
                                  },
                                  expression: "vacantPropertyLeakTest",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Vacant Property Leak Test\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-6 left" },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.smsAllowed,
                                  callback: function ($$v) {
                                    _vm.smsAllowed = $$v
                                  },
                                  expression: "smsAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Send Texts\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.emailAllowed,
                                  callback: function ($$v) {
                                    _vm.emailAllowed = $$v
                                  },
                                  expression: "emailAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Send Emails\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.highflowSmsAllowed,
                                  callback: function ($$v) {
                                    _vm.highflowSmsAllowed = $$v
                                  },
                                  expression: "highflowSmsAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Highflow SMS Allowed\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-6 left" },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.frozenPipe,
                                  callback: function ($$v) {
                                    _vm.frozenPipe = $$v
                                  },
                                  expression: "frozenPipe",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Frozen Pipe\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clear" }),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Leak Repaired Survey")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.leakRepairedSurvey,
                                callback: function ($$v) {
                                  _vm.leakRepairedSurvey = $$v
                                },
                                expression: "leakRepairedSurvey",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Leak Active No Diagnose Survey"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.leakActiveNoDiagnoseSurvey,
                                callback: function ($$v) {
                                  _vm.leakActiveNoDiagnoseSurvey = $$v
                                },
                                expression: "leakActiveNoDiagnoseSurvey",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Install Success Survey")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.installSuccessSurvey,
                                callback: function ($$v) {
                                  _vm.installSuccessSurvey = $$v
                                },
                                expression: "installSuccessSurvey",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Leak Active Survey")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.leakActiveSurvey,
                                callback: function ($$v) {
                                  _vm.leakActiveSurvey = $$v
                                },
                                expression: "leakActiveSurvey",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-modal",
                  {
                    ref: "editTenant",
                    attrs: {
                      id: "modalEditTenant",
                      title: "Update Tenant",
                      "ok-variant": "primary",
                      "ok-title": "Update Tenant",
                      "cancel-title": "Cancel",
                    },
                    on: { ok: _vm.updateTenant },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("p", [_c("strong", [_vm._v("Name")])]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldTenantName,
                                callback: function ($$v) {
                                  _vm.oldTenantName = $$v
                                },
                                expression: "oldTenantName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [_c("strong", [_vm._v("Tenant Code")])]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldTenantCode,
                                callback: function ($$v) {
                                  _vm.oldTenantCode = $$v
                                },
                                expression: "oldTenantCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Leak Days Threshold")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldLeakDaysThreshold,
                                callback: function ($$v) {
                                  _vm.oldLeakDaysThreshold = $$v
                                },
                                expression: "oldLeakDaysThreshold",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Leak Reminder Frequency")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldLeakReminderFrequency,
                                callback: function ($$v) {
                                  _vm.oldLeakReminderFrequency = $$v
                                },
                                expression: "oldLeakReminderFrequency",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Max Number Of Leak Alert Reminders"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldMaxNumberOfLeakAlertReminders,
                                callback: function ($$v) {
                                  _vm.oldMaxNumberOfLeakAlertReminders = $$v
                                },
                                expression: "oldMaxNumberOfLeakAlertReminders",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Monthly Updates Frequency"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldMonthlyUpdatesFrequency,
                                callback: function ($$v) {
                                  _vm.oldMonthlyUpdatesFrequency = $$v
                                },
                                expression: "oldMonthlyUpdatesFrequency",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Install Chasers Frequency"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldInstallChasersFrequency,
                                callback: function ($$v) {
                                  _vm.oldInstallChasersFrequency = $$v
                                },
                                expression: "oldInstallChasersFrequency",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Max Number of Install Chasers"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldMaxNumberOfInstallChasers,
                                callback: function ($$v) {
                                  _vm.oldMaxNumberOfInstallChasers = $$v
                                },
                                expression: "oldMaxNumberOfInstallChasers",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Lost Connection Frequency"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldLostConnectionFrequency,
                                callback: function ($$v) {
                                  _vm.oldLostConnectionFrequency = $$v
                                },
                                expression: "oldLostConnectionFrequency",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  "Max Number of Lost Connection Reminders"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value:
                                  _vm.oldMaxNumberofLostConnectionReminders,
                                callback: function ($$v) {
                                  _vm.oldMaxNumberofLostConnectionReminders =
                                    $$v
                                },
                                expression:
                                  "oldMaxNumberofLostConnectionReminders",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Frozen Pipe Threshold")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldFrozenPipeThreshold,
                                callback: function ($$v) {
                                  _vm.oldFrozenPipeThreshold = $$v
                                },
                                expression: "oldFrozenPipeThreshold",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-6 left" },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.oldSurveyAllowed,
                                  callback: function ($$v) {
                                    _vm.oldSurveyAllowed = $$v
                                  },
                                  expression: "oldSurveyAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Survey Allowed\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.oldWaterUsageAllowed,
                                  callback: function ($$v) {
                                    _vm.oldWaterUsageAllowed = $$v
                                  },
                                  expression: "oldWaterUsageAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Water Usage Allowed\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.oldLeakDaysAllowed,
                                  callback: function ($$v) {
                                    _vm.oldLeakDaysAllowed = $$v
                                  },
                                  expression: "oldLeakDaysAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Leak Days Allowed\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.oldMonthlyUpdatesAllowed,
                                  callback: function ($$v) {
                                    _vm.oldMonthlyUpdatesAllowed = $$v
                                  },
                                  expression: "oldMonthlyUpdatesAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Monthly Updates Allowed\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.oldVacantPropertyLeakTest,
                                  callback: function ($$v) {
                                    _vm.oldVacantPropertyLeakTest = $$v
                                  },
                                  expression: "oldVacantPropertyLeakTest",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Vacant Property Leak Test\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-6 left" },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.oldSmsAllowed,
                                  callback: function ($$v) {
                                    _vm.oldSmsAllowed = $$v
                                  },
                                  expression: "oldSmsAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Send Texts\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.oldEmailAllowed,
                                  callback: function ($$v) {
                                    _vm.oldEmailAllowed = $$v
                                  },
                                  expression: "oldEmailAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Send Emails\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.oldHighflowSmsAllowed,
                                  callback: function ($$v) {
                                    _vm.oldHighflowSmsAllowed = $$v
                                  },
                                  expression: "oldHighflowSmsAllowed",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Highflow SMS Allowed\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-6 left" },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  plain: true,
                                  value: "1",
                                  "unchecked-value": "0",
                                },
                                model: {
                                  value: _vm.oldFrozenPipe,
                                  callback: function ($$v) {
                                    _vm.oldFrozenPipe = $$v
                                  },
                                  expression: "oldFrozenPipe",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Frozen Pipe\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clear" }),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Leak Repaired Survey")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldLeakRepairedSurvey,
                                callback: function ($$v) {
                                  _vm.oldLeakRepairedSurvey = $$v
                                },
                                expression: "oldLeakRepairedSurvey",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [
                                _vm._v("Leak Active No Diagnose Survey"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldLeakActiveNoDiagnoseSurvey,
                                callback: function ($$v) {
                                  _vm.oldLeakActiveNoDiagnoseSurvey = $$v
                                },
                                expression: "oldLeakActiveNoDiagnoseSurvey",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Install Success Survey")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldInstallSuccessSurvey,
                                callback: function ($$v) {
                                  _vm.oldInstallSuccessSurvey = $$v
                                },
                                expression: "oldInstallSuccessSurvey",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("p", [
                              _c("strong", [_vm._v("Leak Active Survey")]),
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "col-md-10",
                              attrs: { type: "text" },
                              model: {
                                value: _vm.oldLeakActiveSurvey,
                                callback: function ($$v) {
                                  _vm.oldLeakActiveSurvey = $$v
                                },
                                expression: "oldLeakActiveSurvey",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }